import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toDate = (v) => (v ? new Date(`${v}T00:00:00`) : undefined);

export function DatePicker({ value, onChange, testId, min, max }) {
  const [open, setOpen] = useState(false);
  const date = toDate(value);
  const disabled = [];
  if (min) disabled.push({ before: toDate(min) });
  if (max) disabled.push({ after: toDate(max) });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className="flex h-9 w-40 items-center gap-2 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-700">
          <CalendarIcon className="h-4 w-4 text-slate-400" />{date ? format(date, "dd MMM yyyy") : "Pick date"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <Calendar mode="single" selected={date} defaultMonth={date} disabled={disabled}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
